module.exports = __webpack_public_path__ + "static/media/parent-sessions.85868ff6.jpeg";